<template>
  <div class="container-box">
    <!-- 基础信息 -->
    <div class="hearder-title">
      <div class="flex_between">
        <img
          class="title-icon" 
          src="@/assets/svg/bsaicIcon.svg"
          alt="dark"
        />
        基础信息
      </div>
    </div>
    <div class="form-container">
      <!-- 表单内容 -->
      <el-form :inline="true" v-if="!isLookOperate" :model="qualityData" label-width="85px">
        <!-- 反馈单号 -->
        <el-form-item label="反馈单号">
          <el-input disabled v-model="qualityData.feedbackFormId"></el-input>
        </el-form-item>
        <!-- 所属经销商 -->
        <!-- <el-form-item label="所属经销商">
          <el-input disabled v-model="qualityData.customerName"></el-input>
        </el-form-item> -->
        <!-- 国家 -->
        <el-form-item label="国家">
          <el-select disabled filterable clearable v-model="qualityData.countryDataId">
            <el-option
              v-for="item in countryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-descriptions :column="3" border v-else>
        <el-descriptions-item label="反馈单号">
          {{qualityData.feedbackFormId}}
        </el-descriptions-item>
        <!-- <el-descriptions-item label="所属经销商">
          {{qualityData.customerName}}
        </el-descriptions-item> -->
        <el-descriptions-item label="国家">
          <div v-for="item in countryList" :key="item.id">
            <div v-if="item.id == qualityData.countryDataId">{{item.name}}</div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- 存在问题 -->
    <div class="hearder-title">
      <div class="flex_between">
        <img class="title-icon" src="@/assets/svg/faultIcon.svg" alt="dark" />
        存在问题
      </div>
    </div>
    <!-- 表格搜索条件表单 -->
    <!-- <div class="filter-container" v-if="isLookOperate">
      <el-form :inline="true" :model="queryParams" label-width="85px">
        <el-form-item label="故障描述">
          <el-input v-model="queryParams.questionContent" placeholder="请输入故障描述"></el-input>
        </el-form-item>
        <el-button class="primary-btn" type="primary" @click="doSearch">
            <i class="subSearch-icon"></i>
            查询
          </el-button>
          <el-button class="primary-btn" icon="el-icon-refresh-right" plain @click="handleResetQuery">
            重置
          </el-button>
      </el-form>
    </div> -->
    <!-- 表格内容 -->
    <div class="table-container">
      <div class="table-btn" v-if="$route.query.operate !== 'look'">
        <!-- 新增问题 -->
        <el-button
          v-if="$route.query.operate !== 'look'"
          class="primary-btn"
          type="text"
          icon="el-icon-plus"
          size="small"
          @click="handleAddOrEdit('新增问题')"
          >新增问题</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tableData"
        stripe
      >
        <!-- 序号 -->
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ getColumnIndex(scope.$index) }}
          </template>
        </el-table-column>
        <!-- 问题序号 -->
        <el-table-column
          prop="questionNum"
          label="问题序号"
          min-width="130px"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <!-- <div class="questionNum"> -->
              <!-- <img
                v-if="scope.row.importantType === 1"
                class="title-icon"
                src="@/assets/img/import-icon.svg"
              /> -->
              {{ scope.row.questionNum }}
            <!-- </div> -->
          </template>
        </el-table-column>
        <!-- 是否重点问题 -->
        <el-table-column property="importantType" :label="'是否重点问题'" width="110px"
                         align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.importantType == 1" style="color:#f56c6c">是</span>
            <span v-if="scope.row.importantType == 0">否</span>
          </template>
        </el-table-column>
        <!-- 销售订单号 -->
        <el-table-column
          prop="orderNum"
          label="销售订单号"
          show-overflow-tooltip
          align="center"
          min-width="120"
        >
        </el-table-column>
        <!-- 车型 -->
        <el-table-column
          property="carModel"
          :label="'车型'"
          min-width="120px"
          align="center"
        >
        </el-table-column>
        <!-- 订单车辆数量 -->
        <el-table-column
          prop="carTotal"
          label="订单车辆数量"
          min-width="110px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 故障配件数量 -->
        <el-table-column
          prop="faultTotal"
          label="故障配件数量"
          min-width="110px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 故障率 -->
        <el-table-column
          prop="badTax"
          label="故障率"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('badTax', tableData)"
        >
          <template slot-scope="scope">
            {{ (scope.row.badTax * 100).toFixed(2) + "%" }}
          </template>
        </el-table-column>
        <!-- 零部件类别 -->
        <el-table-column
          property="componentType"
          :label="'零部件类别'"
          min-width="120px"
          align="center"
        >
          <template slot-scope="scope">
            {{ getComponentCategoryLabel(scope.row.componentType) }}
          </template>
        </el-table-column>
        <!-- 故障描述 -->
        <el-table-column
          prop="questionContent"
          label="故障现象描述"
          min-width="200px"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          label="操作"
          width="110px"
          fixed="right"
          align="center"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button
              v-if="$route.query.operate === 'look'"
              size="mini"
              type="text"
              @click="handleLook(scope.row)"
              >查看</el-button
            >
            <!-- 编辑 -->
            <el-button
              v-if="$route.query.operate !== 'look'"
              size="mini"
              type="text"
              @click="handleAddOrEdit('编辑问题', scope.row)"
              >编辑</el-button
            >
            <!-- 删除 -->
            <el-button
              v-if="$route.query.operate !== 'look'"
              size="mini"
              type="text"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
    <!-- <div class="flex_default_center" style="padding-bottom: 20px">
      <el-button size="small" type="primary" @click="back">
        返回
      </el-button>
    </div> -->
    <problem-dialog ref="problemDialog" @success="getDetail" />
  </div>
</template>

<script>
import listCurd from "@/mixins/listCurd";
import { getStorage, setStorageNew, getSession } from "@/util/localStor";
import { questionListApi, problemDeleteApi } from "@/api/feedbackKD";
import ProblemDialog from "./components/problemDialog.vue";
import { getDictItem } from "@/util/dict";
import componentConfig from "@/mixins/componentConfig";

export default {
  components: {
    ProblemDialog
  },
  mixins: [listCurd,componentConfig],
  data() {
    return {
      countryList: Object.values(getSession("countryList")), // 国家列表
      pageName: {
        add: "新增反馈单",
        edit: "编辑反馈单",
        look: "查看反馈单"
      }, // 页面标题
      carTypeList: [], //车型
      qualityData: {}, // 质量反馈数据
      queryParams: {
        feedbackFormId: ""
      }, // 查询参数
      isLookOperate: false,
      type: "kdFeedbackDetail",
      listMethod: questionListApi // 获取表格数据api
    };
  },

  created() {
    // 页面标题
    this.$route.meta.title = this.pageName[this.$route.query.operate];
    this.isLookOperate = this.$route.query.operate === "look" ? true : false;
    sessionStorage.removeItem('goBackPath');
    // 获取车型列表
    this.getCarTypeList();
    // 质量反馈详情数据
    this.qualityData = getStorage("qualityData");
    // if (this.$route.query.customer) {
    //   const customer = JSON.parse(this.$route.query.customer);
    //   this.qualityData.customerName = customer.customerName;
    //   this.qualityData.customerCountry = customer.customerCountry;
    // }
    // 获取表格数据
    this.qualityData.feedbackFormId && this.getList();
    //零部件类别
    this.getTypeList();
  },
  methods: {
    //获取零部件类别
    getComponentCategoryLabel(code) {
      if (this.componentCategoryList && this.componentCategoryList.length > 0) {
        const item = this.componentCategoryList.find((i) => i.code === code);
        if (item && this.componentCategoryName) {
          return item[this.componentCategoryName.get('zh')];
        }
      }
      return code;
    },
    // 查询参数
    getParams() {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      params.feedbackFormId = this.qualityData.feedbackFormId;
      return {
        data: {
          ...params
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      };
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 获取车型列表
    async getCarTypeList() {
      const carTypeList = await getDictItem("carType");
      carTypeList.map(item => {
        this.carTypeList.push({ text: item.value, value: item.code });
      });
    },
    // (新增 | 编辑)问题
    handleAddOrEdit(
      title,
      data = { feedbackFormId: this.qualityData.feedbackFormId }
    ) {
      this.$refs.problemDialog.init(title, data, this.qualityData);
    },
    // 查看问题
    handleLook(data) {
      setStorageNew("problemDataKD", data);
      this.getSetItem();
      // 保存当前路由
      sessionStorage.setItem('goBackPath', this.$route.fullPath);
      this.$router.push("/KDproblemDetailNew/allDetail");
    },
    // 获取反馈单详情
    getDetail(data) {
      this.qualityData.feedbackFormId = this.qualityData.feedbackFormId || data;
      setStorageNew("qualityData", this.qualityData);
      this.getList();
    },
    // 删除问题
    async handleDelete(row) {
      await this.$confirm(`是否确认删除?`, "提示", {
        cancelButtonClass: "confirm-btn-close",
        confirmButtonClass: "confirm-btn-confirm",
        type: "warning"
      });
      const res = await problemDeleteApi({
        data: {
          questionId: row.questionId
        }
      });
      if (res.status == 0) {
        this.$DonMessage.success("删除成功");
        this.getList();
      } else {
        this.$DonMessage.error(res.message);
      }
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
